import { render, staticRenderFns } from "./CorrectionForm.vue?vue&type=template&id=7525cf03&scoped=true&"
import script from "./CorrectionForm.vue?vue&type=script&lang=js&"
export * from "./CorrectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7525cf03",
  null
  
)

export default component.exports